package org.gstechnovos.jexonplastech.styles

import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.rotate
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.ms

val BackToTop = CssStyle {
    base {
        Modifier.rotate(a = 180.deg).transition(Transition.of(property = "rotate", duration = 200.ms))
    }
    hover {
        Modifier.rotate((0).deg)
    }
}